import React from "react"
import TrynowIcon from "../../../components/icons/Trynow"
import IntelIcon from "../../../components/icons/Intel"
import NeurocastIcon from "../../../components/icons/Neurocast"
import CraftIcon from "../../../components/icons/Craft"
import { useMediaQuery } from "react-responsive"
import { TABLET_WIDTH } from "../../../constants/common"

export const CompaniesIcons = () => {
    const isTablet = useMediaQuery({ minWidth: TABLET_WIDTH })

    return (
        <div className="icons-companies">
            <NeurocastIcon width="170px" height={!isTablet ? "70px" : "100px"}/>
            <IntelIcon width="70px" height={!isTablet ? "70px" : "100px"}/>
            <TrynowIcon width="110px" height={!isTablet ? "70px" : "100px"}/>
            <CraftIcon width="125px" height={!isTablet ? "70px" : "100px"}/>
        </div>
    )
}
